import { createSelector } from 'reselect';

const artisanPublicInquiriesStateSelector = (state) =>
  state.customerPublicArtisanInquiries;

const selectById = (state, itemId) => itemId;

export const artisanPublicInquiriesSelector = createSelector(
  [artisanPublicInquiriesStateSelector],
  (inquiries) => inquiries.items
);

export const inquiryByIdSelector = createSelector(
  [artisanPublicInquiriesSelector, selectById],
  (inquiries, _id) => {
    // const editedInquiry = inquiries.map((inquiry) => ({
    //   title: inquiry.title,
    //   message: inquiry.message,
    //   _id: inquiry._id,
    //   artisanCID: inquiry?.artisanCID[0]
    // }))
    const inquiry = inquiries.find((item) => _id === item._id);
    if (!inquiry) return null;
    return inquiry;
  }
);

export const artisanPublicInquiriesIsLoadingSelector = createSelector(
  [artisanPublicInquiriesStateSelector],
  (inquiries) => inquiries.isLoading
);

export const PublicArtisanListSelector = createSelector(
  [artisanPublicInquiriesSelector],
  (inquiries) =>
    inquiries.map((inquiry) => ({
      proposals: inquiry.proposals,
      name: inquiry.businessName,
      message: inquiry.message,
      _id: inquiry._id,
      moderated: inquiry.moderated,
      title: inquiry.title
    }))
);

export const inquiryCountSelector = createSelector(
  [artisanPublicInquiriesStateSelector],
  (inquiry) => inquiry.count
);
